/**
 * Touch handler
 */
class TouchHandler {
  /** @param {HTMLElement} el */
  constructor(el) {
    this._el = el;
    this._handlers = [];
    this._wrappedHandlers = [];
  }

  /**
   * @param {String} event
   * @param {Function} fn
   * @return {Function}
   */
  _wrapper(event, fn) {
    let prevClientX = null;
    let prevClientY = null;

    return function(e) {
      const touchEvent = e.changedTouches[0];

      if (e.type === 'touchstart') {
        const target = e.target;
        const link = target.closest('a');

        if (!link) {
          e.preventDefault();
        }

        prevClientX = touchEvent.clientX;
        prevClientY = touchEvent.clientY;
      } else {
        const currClientX = touchEvent.clientX;
        const currClientY = touchEvent.clientY;
        const deltaX = currClientX - prevClientX;
        const deltaY = currClientY - prevClientY;

        if (deltaY > 0 && event === 'swipeY') {
          fn('swipeup');
        } else if (deltaY < 0 && event === 'swipeY') {
          fn('swipedown');
        } else if (deltaX > 0 && event === 'swipeX') {
          fn('swipeleft');
        } else if (deltaX < 0 && event === 'swipeX') {
          fn('swiperight');
        }
      }
    };
  }

  /**
   * @param {String} event
   * @param {Function} fn
   */
  on(event, fn) {
    const countHandlers = this._handlers.push(fn);
    const index = countHandlers - 1;
    const handler = this._wrapper(event, fn);

    this._wrappedHandlers[index] = handler;

    this._el.addEventListener('touchstart', handler);
    this._el.addEventListener('touchend', handler);
  }

  /**
   * @param {String} event
   * @param {Function} fn
   */
  off(event, fn) {
    const index = this._handlers.indexOf(fn);

    if (index === -1) {
      return;
    }

    const handler = this._wrappedHandlers[index];

    this._el.removeEventListener('touchend', handler);
    this._el.removeEventListener('touchstart', handler);

    delete this._handlers[index];
    delete this._wrappedHandlers[index];
  }
}

export default TouchHandler;



// WEBPACK FOOTER //
// ./src/js/TouchHandler.js